export const colors = {
  light: {
    primary: 'rgba(84, 62, 224, 1)',
    secondary: 'rgb(59 73 223 / 10%)',
    bg: 'rgb(255, 255, 255)',
    color: 'rgb(23, 25, 35)',
    cardBg: 'rgb(255, 255, 255)',
    cardSecondaryBg: 'rgb(250, 250, 250)',
    cardColor: 'rgb(250, 250, 250)',
    cardSecondaryColor: 'rgb(64, 64, 64)',
    cardBorder: 'rgb(23 23 23 / 10%)',
    footerBg: 'rgb(229, 229, 229)',
    footerColor: 'rgb(64, 64, 64)',
    headingHover: 'rgb(71, 50, 207)',
    linkColor: 'rgb(64, 64, 64)',
    tagColorHover: 'rgb(23, 25, 35)',
    ghostColor: '#3d3d3d',
    colorTertiary: 'rgb(82, 82, 82)',
    colorHover: '#090909',
    base70: '#575757',
  },

  dark: {
    primary: 'rgb(129, 140, 248)',
    secondary: 'rgb(49 46 129 / 75%)',
    bg: 'rgb(23, 25, 35)',
    color: 'rgb(250, 250, 250)',
    cardBg: 'rgb(23, 25, 35)',
    cardSecondaryBg: 'rgb(23, 25, 35)',
    cardColor: 'rgb(23, 25, 35)',
    cardSecondaryColor: 'rgb(229, 229, 229)',
    cardBorder: 'rgb(255 255 255 / 15%)',
    footerBg: 'rgb(23, 25, 35)',
    footerColor: 'rgb(163, 163, 163)',
    headingHover: 'rgb(165, 180, 252)',
    linkColor: 'rgb(212, 212, 212)',
    tagColorHover: 'rgb(245 245 245)',
    ghostColor: '#d6d6d7',
    colorHover: '#f9f9f9',
    colorTertiary: 'rgb(163, 163, 163)',
    base70: '#bdbdbd',
  },
};
